<template>
    <div class="vip-page">
        <firm-set-info :vip-info="privilegeInfo" :local-star-info="localStarInfo"></firm-set-info>
        <div class="filter-box">
            <veui-form
                class="form-box"
                :data="formData"
                @submit="getLawyers()"
            >
                <veui-field
                    name="lawyerName"
                    label=""
                >
                    <veui-input
                        v-model="formData.lawyerName"
                        trim
                        placeholder="请输入律师名称"
                        class="select"
                    />
                </veui-field>
                <veui-button
                    ui="primary"
                    type="submit"
                    class="search"
                >
                    查找
                </veui-button>
            </veui-form>
        </div>
        <!-- 表格 -->
        <article :class="setList.length > 0 ? 'table' : 'table no-data'">
            <veui-table
                ui="l"
                :data="setList"
                key-field="id"
                role="columnheader"
                :loading="loading"
            >
                <veui-table-column
                    field="lawyerInfo"
                    title="律师信息"
                    width="250"
                >
                    <template #default="{name, personalAvatar}">
                        <div class="layer-info">
                            <img
                                v-if="personalAvatar"
                                class="avatar"
                                :src="personalAvatar"
                            />
                            <div class="name">{{ name }}</div>
                        </div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="prov"
                    title="执业地"
                    width="160"
                >
                    <template #default="{prov, city}">
                        <div class="layer-info">
                            <div class="name">{{ prov }}-{{ city }}</div>
                        </div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="register_law_firm"
                    title="执业律所"
                    width="160"
                >
                </veui-table-column>
                <veui-table-column
                    field="clueStatus"
                    title="线索权益授权"
                >
                    <template #default="{index, clueStatus}">
                        <div
                            v-if="isFirmVip"
                            :class="['switch-box', clueStatus.value === 1 ? 'active' : 'no-active']"
                            @click.self="switchClick(index, 'clueStatus')"
                        >
                            <veui-switch
                                v-model="clueStatus.value"
                                :true-value="1"
                                :false-value="0"
                                class="switch"
                                @change="changeSet(index, 'clueStatus')"
                            >
                            </veui-switch>
                        </div>
                        <div v-else>不支持授权</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="contentStatus"
                    title="内容权益授权"
                >
                    <template #default="{index, contentStatus, isAdmin}">
                        <div
                            v-if="!isAdmin && isFirmVip"
                            :class="['switch-box', contentStatus.value === 1 ? 'active' : 'no-active']"
                            @click.self="switchClick(index, 'contentStatus')"
                        >
                            <veui-switch
                                v-model="contentStatus.value"
                                :true-value="1"
                                :false-value="0"
                                class="switch"
                                @change="changeSet(index, 'contentStatus')"
                            >
                            </veui-switch>
                        </div>
                        <div v-else>不支持授权</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="vipStatus"
                    title="成员尊享权益授权"
                >
                    <template #default="{index, vipStatus, isAdmin}">
                        <div
                            v-if="!isAdmin && isFirmVip"
                            :class="['switch-box', vipStatus.value === 1 ? 'active' : 'no-active']"
                            @click.self="switchClick(index, 'vipStatus')"
                        >
                            <veui-switch
                                v-model="vipStatus.value"
                                :true-value="1"
                                :false-value="0"
                                class="switch"
                                @change="changeSet(index, 'vipStatus')"
                            >
                            </veui-switch>
                        </div>
                        <div v-else>不支持授权</div>
                    </template>
                </veui-table-column>
                <template #no-data>
                    <div v-if="!loading" class="blank">
                        <div class="icon"></div>
                        <div class="text">暂无信息</div>
                    </div>
                </template>
            </veui-table>
        </article>
        <!-- 分页 -->
        <article v-if="setList && setList.length" class="pagination">
            <veui-pagination
                :page="pn"
                :total="total"
                :show-total="!!total"
                :page-size="rn"
                @redirect="pageChange"
            />
        </article>
    </div>

</template>

<script>
/**
 * @file index.vue
 * @author zhengyixin
 * @desc 会员权益设置
 */
import {
    Form,
    Field,
    Button,
    Pagination,
    Table,
    Column,
    Input,
    Switch
} from 'veui';
import FirmSetInfo from './firmSetInfo';
import {mapState, mapActions} from 'vuex';
import isEmpty from 'lodash/isEmpty';
const url = {
    getBusinessMember: '/bp/api/business/getlawyerlist',
    changeBusinessMember: '/bp/api/business/changemember',
    vipBuyIndex: '/bp/api/vip/claim_clue_index'
};
export default {
    name: 'vipSet',
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-button': Button,
        'veui-pagination': Pagination,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-input': Input,
        'firm-set-info': FirmSetInfo,
        'veui-switch': Switch
    },
    data() {
        return {
            loading: true,
            formData: {
                lawyerName: null
            },
            setList: [], // 表格数据
            selectOption: [
                {
                    label: '关闭',
                    value: 0
                },
                {
                    label: '开通',
                    value: 1
                }
            ],
            pn: 1,
            rn: 10,
            total: 0,
            businessId: 0,
            lawyerAdmin: {}, // 律所管理员数据
            localStarInfo: []
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.lawStore.userInfo,
            vipInfo: state => state.lawStore.vipInfo,
            userInfoNew: state => state?.lawStore?.userInfoNew
        }),
        isFirmVip() {
            return this.vipInfo?.business_privilege_info?.is_vip || false;
        },
        privilegeInfo() {
            let {privilege_info} = this.vipInfo || {};
            return {
                clueQuota: privilege_info?.clue_quota || 0,
                lawyerAladdinCard: privilege_info?.lawyer_aladdin_card || 0,
                contentQuota: privilege_info?.content_quota || 0
            };
        }
    },
    watch: {
        userInfoNew: {
            handler(val = {}) {
                if (!val) {
                    return;
                }
                this.businessId = val?.law_business_info?.id || 0;
                this.getLawyers();
            }
        }
    },
    created() {
        this.getReceiveClueInfo();
        if (!isEmpty(this.userInfoNew)) {
            this.businessId = this.userInfoNew?.law_business_info?.id || 0;
            this.getLawyers();
            return;
        }
        // 更新用户信息接口
        this.getUserInfoNew();
    },
    methods: {
        ...mapActions({
            getUserInfoNew: 'lawStore/getUserInfoNew',
            getVipInfo: 'lawStore/getVipInfo'
        }),
        getLawyers() {
            const name = this.formData.lawyerName || '';
            if (name === '律所管理员') {
                let setList = [];
                setList.push(this.lawyerAdmin);
                this.setList = setList;
                this.total = 1;
                return;
            }
            const params = {
                businessId: this.businessId,
                pn: this.pn,
                rn: this.rn,
                name
            };
            this.$http.get(url.getBusinessMember, {
                params
            }).then(res => {
                const data = this.$normalizeResponseData(res);
                const list = data?.list || [];
                const businessInfo = data?.business_info || {};
                let setList = [];
                list.forEach(item => {
                    const {name, personalAvatar, enableClue, enableVip, enableContent, isAdmin, uk, prov, city, register_law_firm} = item;
                    const element = {
                        name,
                        personalAvatar,
                        isAdmin,
                        uk,
                        clueStatus: {
                            value: enableClue || 0
                        },
                        vipStatus: {
                            value: enableVip || 0
                        },
                        contentStatus: {
                            value: enableContent || 0
                        },
                        prov,
                        city,
                        register_law_firm
                    };
                    setList.push(element);
                });
                this.setList = setList;
                if (this.pn === 1 && name.length <= 0) {
                    const lawyer = {
                        name: '律所管理员',
                        personalAvatar: '',
                        clueStatus: {
                            value: businessInfo.enable_clue
                        },
                        vipStatus: {
                            value: 0
                        },
                        contentStatus: {
                            value: 0
                        },
                        isAdmin: 1
                    };
                    this.lawyerAdmin = lawyer;
                    this.setList.unshift(lawyer);
                }
                this.total = data?.count ? +data.count : 0;
                this.loading = false;
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.loading = false;
            });
        },
        pageChange(page) {
            this.pn = page;
            this.getLawyers();
        },
        changeSet(index, type) {
            const obj = this.setList[index];
            const params = {
                businessId: this.businessId,
                name: obj.name,
                uk: obj.uk,
                enableClue: obj.clueStatus.value,
                enableVip: obj.vipStatus.value,
                enableContent: obj.contentStatus.value
            };
            if (obj.isAdmin) {
                params.isPrimary = 1;
            }
            this.$http.post(url.changeBusinessMember, {
                ...params
            }).then(res => {
                if (+res.code !== 0) {
                    this.setList[index][type].value = (obj[type] && +obj[type].value === 1 ? 0 : 1);
                    this.$Message.error(res?.msg || '操作失败');
                    return;
                }
                this.$Message.success('操作成功');
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.setList[index][type].value = (obj[type] && +obj[type].value === 1 ? 0 : 1);
            });
        },
        getReceiveClueInfo() {
            this.$http.get(url.vipBuyIndex, {
                params: {
                    user_type: this.userInfoNew.user_role
                }
            }).then(res => {
                if (+res.code !== 0 || !res.data) {
                    return;
                }
                this.localStarInfo = res.data.user_info?.localstar_info || [];
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },

        /**
         * 开关切换
         */

        switchClick(index, type) {
            const obj = this.setList[index];
            if (obj[type]) {
                obj[type].value = obj[type].value ? 0 : 1;
            }
            this.changeSet(index, type);
        }
    }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/law-table.less";

.vip-page {
    line-height: 1;
    background: #fff;
    padding: 24px 0;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;

    .filter-box {
        padding: 0 30px;
    }

    .form-box {
        margin-top: 26px;
        display: flex;
        width: 100%;

        .veui-field-no-label {
            margin-left: 0;
        }

        /deep/ .veui-input {
            color: #333;
            border-radius: 8px;
            height: 40px;
        }

        .select {
            width: 224px;
        }

        .search {
            height: 40px;
            margin-left: 16px;
        }
    }

    .table {
        padding: 0 30px;

        .layer-info {
            display: flex;
            align-items: center;

            .avatar {
                height: 40px;
                width: 40px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }

        .opt-select {
            width: 102px;
        }

        .switch-box {
            position: relative;

            &.no-active::after,
            &.active::after {
                cursor: pointer;
                position: absolute;
                z-index: 1;
                top: 0;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
            }

            &.no-active::after {
                content: "关";
                right: 6px;
                color: rgba(255, 255, 255, .9);
            }

            &.active::after {
                content: "开";
                left: 6px;
                color: #fff;
            }

            /deep/ .veui-switch {
                &.veui-switch-on:not(.veui-switch-loading) > .veui-switch-switcher > .veui-switch-button {
                    transform: translateX(20px);
                }

                .veui-switch-switcher {
                    width: 40px;
                    height: 20px;
                }
            }
        }
    }

    .pagination {
        text-align: right;
        padding: 30px 30px 0;
    }
}
</style>